import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { AuthService } from '../../services/auth/auth.service';
import { ConfigService } from '../../services/config/config.service';
import { ReturnUrlService } from '../../services/return-url/return-url.service';
import { VideoPortalUser } from '../../services/auth/video-portal-user.model';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, OnDestroy {
    environment: string;
    productName: string;
    currentUser: VideoPortalUser | null = null;
    private destroy$ = new Subject<void>();

    constructor(private authService: AuthService,
                private returnUrlService: ReturnUrlService,
                configService: ConfigService) {
        this.environment = configService.config.environment;
        this.productName = configService.config.productName;
    }

    ngOnInit(): void {
        this.authService.userInfoSubject
            .pipe(takeUntil(this.destroy$))
            .subscribe(user => {
                this.currentUser = user;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    get isLoginInProgress(): boolean {
        return this.authService.isLoginInProgress;
    }

    isLoggedIn(): boolean {
        return !!this.currentUser;
    }

    login(): void {
        this.returnUrlService.clear();
        this.authService.login();
    }

    logout(): void {
        this.authService.logout();
    }

    councilName(): string {
        return this.currentUser ? this.currentUser.councilName : '';
    }

    userName(): string {
        return this.currentUser ? this.currentUser.username : '';
    }
}
